import React from 'react';
import { useArchitectureStore } from '../../store/useArchitectureStore';
import { RefreshCw, ArrowRight, Upload } from 'lucide-react';

const BlueprintBridge: React.FC = () => {
    const { startTask } = useArchitectureStore();

    const handleStartWorkflow = () => {
        startTask('PLAN_TO_ELEVATION');
    };

    return (
        <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2 text-stone-500 px-1">
                <RefreshCw size={14} />
                <span className="text-xs font-bold uppercase tracking-widest">Blueprint Bridge</span>
            </div>

            <div className="p-3 rounded-xl bg-stone-900/40 border border-stone-800 flex flex-col gap-3">
                <div className="text-xs text-stone-400 font-medium text-center">
                    Convert 2D Plans to 3D Perspectives
                </div>

                <div className="grid grid-cols-2 gap-2">
                    <button className="flex flex-col items-center gap-2 p-3 rounded-lg bg-black/20 hover:bg-black/40 border border-stone-800 hover:border-stone-700 transition-all group">
                        <Upload size={20} className="text-stone-500 group-hover:text-stone-300" />
                        <span className="text-[10px] text-stone-500 group-hover:text-stone-400">Upload Plan</span>
                    </button>
                    <button
                        onClick={handleStartWorkflow}
                        className="flex flex-col items-center gap-2 p-3 rounded-lg bg-gradient-to-br from-indigo-900/50 to-purple-900/50 hover:from-indigo-900/80 hover:to-purple-900/80 border border-indigo-500/30 hover:border-indigo-400/50 transition-all text-indigo-200"
                    >
                        <div className="">
                            <ArrowRight size={20} />
                        </div>
                        <span className="text-[10px]">Start Wizard</span>
                    </button>
                </div>

                <div className="h-1 w-full bg-stone-800 rounded-full overflow-hidden">
                    {/* Progress bar placeholder if needed later, or remove */}
                </div>
            </div>
        </div>
    );
};

export default BlueprintBridge;
